import { render, staticRenderFns } from "./chemBasePop.vue?vue&type=template&id=49d2df24"
import script from "./chemBasePop.vue?vue&type=script&lang=js"
export * from "./chemBasePop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49d2df24')) {
      api.createRecord('49d2df24', component.options)
    } else {
      api.reload('49d2df24', component.options)
    }
    module.hot.accept("./chemBasePop.vue?vue&type=template&id=49d2df24", function () {
      api.rerender('49d2df24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/mam/chem/chemBasePop.vue"
export default component.exports